import React from 'react'
import './CSS/LoginSignup.css'

const LoginSignUp = () => {
  return (
    <div className='loginsignup'>
      <div className="loginsignup-container">
        <h1>Sign Up</h1>
        <div className="loginsignup-fields">
    <input type="text" placeholder='Your name' />
    <input type="email"  placeholder='Email Address'/>
    <input type="password"  placeholder='password' />
        </div>
         <button>Continue</button>

         <p className="loginsignup-login">Already have An Account ? <span>Login here</span></p>
         <div className="loginsignup-agree">
          <input type="checkbox" name='' id='' />
          <p>By continuing, i agree to the  terns and conditions or privacy terms</p>
         </div>
      </div>
    </div>
  )
}

export default LoginSignUp
